/* eslint-disable @typescript-eslint/no-explicit-any */
// This file MUST be imported at the very top of your main application entry point
// to set the public path for dynamic assets (for VideoSDK and similar libraries)
// before any of their code is loaded.

// This path assumes that the VideoSDK media processor assets have been copied to
// the `public/videosdk-processor-assets/` directory in your project.
const publicPath = '/videosdk-processor-assets/';

if (typeof window !== 'undefined') {
  (window as any).__webpack_public_path__ = publicPath;
}

if (typeof globalThis !== 'undefined') {
  (globalThis as any).__webpack_public_path__ = publicPath;
}
